import { apiRequest } from './client'

export interface User {
  id: string
  email: string
  plan: string
  domain: string | null
  display_name: string | null
  email_verified: boolean
}

interface AuthResponse {
  token: string
  user: User
}

export async function signup(email: string, password: string): Promise<AuthResponse> {
  return apiRequest<AuthResponse>('/api/auth/signup', {
    method: 'POST',
    body: { email, password },
  })
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  return apiRequest<AuthResponse>('/api/auth/login', {
    method: 'POST',
    body: { email, password },
  })
}

export async function logout(): Promise<void> {
  return apiRequest<void>('/api/auth/logout', { method: 'POST' })
}

export async function getMe(): Promise<User> {
  return apiRequest<User>('/api/auth/me')
}

export async function updateDomain(domain: string): Promise<User> {
  return apiRequest<User>('/api/auth/domain', {
    method: 'PUT',
    body: { domain },
  })
}

export async function updateDisplayName(displayName: string): Promise<User> {
  return apiRequest<User>('/api/auth/display-name', {
    method: 'PUT',
    body: { displayName },
  })
}

export async function verifyEmail(token: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>('/api/auth/verify-email', {
    method: 'POST',
    body: { token },
  })
}

export async function resendVerification(): Promise<{ ok: true; alreadyVerified: boolean }> {
  return apiRequest<{ ok: true; alreadyVerified: boolean }>('/api/auth/resend-verification', {
    method: 'POST',
  })
}
